



















import { RuleInterface } from '../../../types'
import { testRules } from '../../services/PuzzleFactory'
import Vue from 'vue'

enum Status {
  Default = 'default',
  Failure = 'failure',
  Success = 'success'
}

export default Vue.extend({
  name: 'Footer',

  props: {
    attempt: {
      required: true,
      type: Array as () => Array<number>
    },

    correctAnswers: {
      required: true,
      type: Number
    },

    rules: {
      required: true,
      type: Array as () => Array<RuleInterface>
    }
  },

  data: () => ({
    status: Status.Default as string
  }),

  computed: {
    puzzleCount(): number {
      return this.correctAnswers + 1
    }
  },

  methods: {
    next() {
      this.$emit('nextGame')
      this.status = Status.Default
    },

    test() {
      const passTheTest = testRules(this.attempt, this.rules)

      if (passTheTest) {
        this.status = Status.Success
        this.$emit('correctAnswer')
      } else {
        this.status = Status.Failure
        setTimeout(() => {
          this.status = Status.Default
        }, 2000)
      }
    }
  }
})
